import { ErrorOutline, KeyboardArrowDown } from "@mui/icons-material";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  InputBase,
  MenuItem,
  Select,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import planData from '../plans.json';
import { useLocation, useNavigate } from "react-router-dom";
import AddToSlackModal from "./AddUserToSlack";
import ChannelAddedModal from "./ChannelAddelModal";
import { jwtDecode } from "jwt-decode";
import generatecode from "../utils/generateCode";
import CryptoJS from "crypto-js";
import posthog from "posthog-js";
import forge from "node-forge";
import encryptApi from "../utils/encryptApi";
import decryptApi from "../utils/decryptApi";
const AddChannelModal = ({ open, setOpen, channels, setChannels , channelAddedModal, setOpenChannelAddedModal,channelPendingModal, setOpenChannelPendingModal,addToSlackModal, setOpenAddToSlackModal, setChannelId}) => {
  const location = useLocation(); 
  const [loader, setLoader] = useState(false);
  const [error_msg, setErrormsg] = useState(null);
  const [code_sent, setCodeSent] = useState(false);

  const [planDetails, setPlanDetails] = useState(null);
  const navigate = useNavigate()


   const [code, setCode] = useState(null)
   const [timeLeft, setTimeLeft] = useState(0);
   const searchParams = new URLSearchParams(location.search); // Parse the query string
   const [channel, setChannel] = useState({
    label: "",
    last_updated: String(Math.floor(Date.now() / 1000)),
    status:"active",
    type: searchParams.get("channeltype") || "email",
    value: "",
    organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
    slack_id: "",
    api_key: "",
    front_id: "",
  });


  //get the url param
 // Access the current location
  useEffect(() => {
    
   
    const param1 = searchParams.get("channeltype"); // Get value of 'param1'

    console.log("param1:", param1);

    if (param1 && channel?.type.length >= 1) {
      setLoader(true)
      setOpen(true)
     
      // Remove parameters after 2 seconds
      setTimeout(() => {

         searchParams.delete("channeltype");
         navigate({
           pathname: location.pathname,
           search: searchParams.toString(), // Update the URL without the removed params
         });
      }, 0);
    }
  }, [location]);

   useEffect(()=> {
       setCode(generatecode())
       setCodeSent(false)
       setChannel({...channel, value: '', label:''})
       setErrormsg(null)
   },[channel?.type])

  

  useEffect(() => {
    if (timeLeft === 0) {
      setCode(generatecode())
    };

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId); // Cleanup on unmount or re-render

  }, [timeLeft]);




  const check_subscription = async () => {
    try {
      setLoader(true)
      let sub = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
        {
          customer_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_cust_id.S,
          sub_id: JSON.parse(localStorage.getItem("organization")).subscription_details.M.stripe_sub.S,
        }
      );

      console.log(sub.data)

      console.log(planData[sub.data?.planDetails[0].plan_id])
      setPlanDetails(planData[sub.data?.planDetails[0].plan_id])
      setLoader(false)
      return;
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.message);
      }
      setLoader(false);
    }
 };
 useEffect(() => {
  check_subscription()
}, [])
function generateRandomAlphanumeric() {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const length = 16; // Length of the random string
  let result = '';
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }
  return result;
}
useEffect(() => {
 if(channel?.type === 'front' ){
  let randomalphanumeric = generateRandomAlphanumeric()
  console.log(randomalphanumeric)

  setChannel({...channel, value: randomalphanumeric, front_id: randomalphanumeric,slack_id: randomalphanumeric, status:'pending', api_key : randomalphanumeric })

 }

 if(channel?.type === 'slack')
 {
  setChannel({...channel, value: 'N/A',status:'pending', slack_id: 'N/A', front_id : 'N/A'})
 }
}, [channel?.type])


  async function sendEmailVerificationLink() {
    setErrormsg(null);

    setLoader(true);
    //using node forge to encrypt data
    console.log('ji')

 
    
     try {
       let response = await axios.post(
         process.env.REACT_APP_BACKEND_URL +
           "email/send-email-verification-code",
         {
           email: channel?.type === "email" && channel.value,
           toName: channel.label,
           code: await encryptApi(code)
         }
       );
       console.log(response);
       setCodeSent(true);
         setTimeLeft(60)

       setLoader(false);
     } catch (error) {
       console.log(error);
       if (error.response && error.response.data) {
         console.error("Response data:", error.response.data);
         setErrormsg(error.response.data.message);
       }
       setLoader(false);
     } 
  }


  function decodeToken(token) {
      console.log(token)
          try {
            const decoded = jwtDecode(token);
            console.log({decoded})
            return decoded.api_key;
          } catch (error) {
            console.error('Invalid token:', error);
            return null;
          }
        }
  

  async function sendPhoneVerificationText() {
    setErrormsg(null);
 const ciphertext = CryptoJS.AES.encrypt(code, process.env.REACT_APP_TWILANSWER_SECRET).toString();
    setLoader(true);
    try {
      let response = await axios.post(
        process.env.REACT_APP_BACKEND_URL +
          "twilio/read-num-aloud",
          {
            fromNumber: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration?.M.primary_phone.S,
            forwarding_number: channel.value,
            code: await encryptApi(code),
            account_sid: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration.M.account_sid.S,
            api_key: (JSON.parse(localStorage.getItem("organization")).twilio_integration
              .M.api_key.S),
          }
      );
      console.log(response);
      setCodeSent(true);
      setTimeLeft(60)

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.error);
      }
      setLoader(false);
    }
  }

  async function sendPhoneVerificationSms() {
    setErrormsg(null);

    setLoader(true);
    try {
      let response = await axios.post(
        process.env.REACT_APP_BACKEND_URL +
          "twilio/send-text-message",
          {
            fromNumber: JSON.parse(localStorage.getItem("organization"))
              .twilio_integration?.M.primary_phone.S,
              toNumber: channel.value,
            code: await encryptApi(code)
            ,
          }
      );
      console.log(response);
      setCodeSent(true);
      setTimeLeft(60)

      setLoader(false);
    } catch (error) {
      console.log(error);
      if (error.response && error.response.data) {
        console.error("Response data:", error.response.data);
        setErrormsg(error.response.data.error.message);
      }else{
        setErrormsg(error.response.message)
      }
      setLoader(false);
    }
  }

  

  const [successMsg, setSuccessMsg] = useState(null)

  useEffect(()=> {
setChannel({...channel,organization_id:JSON.parse(localStorage.getItem("organization")).orgId.S})
  },[error_msg])

  const addChannel = async () => {
    setErrormsg(null)

      let check= await axios.post(`${process.env.REACT_APP_BACKEND_URL}get-user-by-id`,{
                      userId: JSON.parse(localStorage.getItem('user')).userId.S
                  });
                  
                  if (check.status === 200) {
                    const user___ = check.data.user;
                    
                    
                    if(user___.relatedOrgs.L?.find((e)=> e?.M.org_id?.S === JSON.parse(localStorage.getItem('organization')).orgId.S)){
                      
                      if(channel.label?.length >= 1){
                       console.log(channel)
                       if (
                         JSON.parse(localStorage.getItem("organization")).channels?.L.find(
                           (e) => e.M.type.S === channel?.type && e.M.value.S === channel.value && e.M.value.S !== 'N/A'
                         )
                       ) {
                         setErrormsg('Another channel with '+channel?.type +" already exist");
                       } else {
                         if ( channel?.type === 'front' || channel?.type === 'slack' ||  channel?.code === code) {
                           try {
                             setLoader(true);
                   
                             let channel_data = await axios.post(
                               process.env.REACT_APP_BACKEND_URL + "add-channel",
                               channel
                             );
                   
                             console.log(channel_data);


                   
                             localStorage.setItem(
                               "organization",
                               JSON.stringify(channel_data.data.updatedItem)
                             );
                   
                             setChannels(channel_data.data.updatedItem.channels.L);
                             setChannelId(channel_data.data.channel_id)
                   
                             if(channel?.type === 'slack'){
                               setOpenAddToSlackModal(true)
                             }
                             if(channel?.type === 'front'){
                               setOpenChannelPendingModal(true)
                             }
                             if(channel?.type === 'email'){
                               setOpenChannelAddedModal(true)
                             }
                   
                             if(channel?.type === 'forward_number'){
                               setOpenChannelAddedModal(true)
                             }
                   
                             if(channel?.type === 'sms'){
                               setOpenChannelAddedModal(true)
                             }
                             setChannel({
                              label: "",
                              last_updated: String(Math.floor(Date.now() / 1000)),
                              status:"active",
                              type: searchParams.get("channeltype") || "email",
                              value: "",
                              organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
                              slack_id: "",
                              api_key: "",
                              front_id: "",
                            });
                   
                             setCodeSent(false)
                   
                             setSuccessMsg('Channel successfully added')
                              //post hog track event for add a channel
                posthog.capture('Added a channel', {
                  email: JSON.parse(localStorage.getItem('user')).email.S,
            userId : JSON.parse(localStorage.getItem('user')).userId.S,
                });
              
                             setTimeout(() => {
                               setSuccessMsg(null)
                             }, 3000);
                             setOpen(false)
                   
                             setLoader(false);
                             setErrormsg(null);
                             setCodeSent(null)
                             setTimeLeft(0)
                   
                   
                           } catch (error) {
                             console.log(error);
                             if (error.response && error.response.data) {
                               console.error("Response data:", error.response.data);
                               setErrormsg(error.response.data.message);
                             }
                             setLoader(false);
                           }
                         } else {
                           setErrormsg("verification code does not match");
                         }
                       }
                      }else{
                       setErrormsg("Please add channel name");
                      }
                    }else{
                      window.location.reload()
                    }
          
                  }
  };


  const [copied, setCopied] = useState(false)

  //copy to clip board
  async function copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      console.log('Text copied to clipboard:', text);
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text:', err);
    }
  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
      }}
    >
      
     
      <div className="px-8 py-6">
        <div className="lg:text-[16px] text-[14px]  font-semibold mb-2">
          {" "}
          Add Channel
        </div>
        {error_msg && (
          <div className=" flex items-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
            <ErrorOutline sx={{ fontSize: "", mr:1 }} /> {error_msg}
          </div>
        )}

{successMsg && (
         <Alert color='success' > 
          <div className=" lg:text-[13px] text-[12px]   font-semibold ">
            {successMsg}
          </div>
         </Alert>
        )}
        <div className="flex justify-center">
          <div className="space-y-5">
            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0 ">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                Channel Type{" "}
                <img
                  src="/icons/tooltip.png"
                  className="w-[15px] lg:ml-3 ml-1"
                />
              </div>

              <div className="lg:w-[200px]">
                <Select
                  IconComponent={KeyboardArrowDown}
                  fullWidth
                  defaultValue={channel?.type}
                  value={channel?.type}
                  onChange={(e) => {
                    setChannel({ ...channel, type: e.target.value });
                  }}
                  className="mb-2 bg-[#F7F7F8]"
                  sx={{
                    fontSize: { lg: "14px", xs: "12px" },
                    padding: "4px 8px", // Adjust padding here
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                      padding: "4px 8px", // Adjust padding for the text inside Select
                    },
                  }}
                >
                  <MenuItem value="email">Email</MenuItem>
                  <MenuItem value="sms">SMS</MenuItem>
                  <MenuItem value="forward_number">Forward Number</MenuItem>
                  <MenuItem value="front">Front Channel</MenuItem>
                  <MenuItem value="slack">Slack Channel</MenuItem>
                </Select>
              </div>
            </div>
            <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
              <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                Channel Nickname{" "}
                <img
                  src="/icons/tooltip.png"
                  className="w-[15px] lg:ml-3 ml-1"
                />
              </div>

              <div className="lg:w-[200px]">
                <InputBase
                  value={channel.label}
                  onChange={(e) => {
                    setChannel({ ...channel, label: e.target.value });
                  }}
                  sx={{
                    bgcolor: "#F7F7F8",
                    width: "100%",
                    px: 2,
                    fontSize: { lg: "14px", xs: "12px" },
                  }}
                />
              </div>
            </div>
            {channel?.type === "email" && (
            <>
              <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                  Email Address
                  <img
                    src="/icons/tooltip.png"
                    className="w-[15px] lg:ml-3 ml-1"
                  />
                </div>

                <div className="lg:w-[200px] mr-2">
                  <InputBase
                    value={channel.value}
                    onChange={(e) => {
                      setChannel({ ...channel, value: e.target.value });
                    }}
                    sx={{
                      bgcolor: "#F7F7F8",
                      width: "100%",
                      px: 2,
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                  />
                </div>

                 
                    <div className="flex lg:justify-center mt-2 lg:mt-0 relative  ">
                   {timeLeft >= 1 ? (
                     <Button
                     sx={{
                       textTransform: "none",
                       bgcolor: "#605BFF",
                       color: "white",
                       py: "1px",
                       px: "10px",
                       borderRadius: "7px",
                       fontSize: { lg: "14px", xs: "12px" },
                     }}
                   >
                     Expires {timeLeft}
                   </Button>
                   ) : (
                    <Button
                    sx={{
                      textTransform: "none",
                      bgcolor: "#605BFF",
                      color: "white",
                      py: "1px",
                      px: "1px",
                      borderRadius: "7px",
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                    onClick={sendEmailVerificationLink}
                  >
                    Verify
                  </Button>
                   )}
                    </div>
              </div>
              {code_sent && (

                <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                  <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                    Verification Code
                    <img
                      src="/icons/tooltip.png"
                      className="w-[15px] lg:ml-3 ml-1"
                    />
                  </div>
  
                  <div className="lg:w-[200px]">
                  <InputBase
                          value={channel.code}
                          onChange={(e) => {
                            setChannel({ ...channel, code: e.target.value });
                          }}
                          placeholder="enter verification code"
                          sx={{
                            bgcolor: "#F7F7F8",
                            width: "100%",
                            px: 2,
                            fontSize: { lg: "14px", xs: "12px" },
                          }}
                        />
                  </div>
  
                  
                   
                </div>
              )}
              </>
            )}
            {channel?.type === "sms" && (
            <>
              <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                  Phone Number
                  <img
                    src="/icons/tooltip.png"
                    className="w-[15px] lg:ml-3 ml-1"
                  />
                </div>

                <div className="lg:w-[200px]">
                  <InputBase
                    value={channel.value}
                    onChange={(e) => {
                      setChannel({ ...channel, value: e.target.value });
                    }}
                    sx={{
                      bgcolor: "#F7F7F8",
                      width: "100%",
                      px: 2,
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                  />
                </div>

              
                    <div className="flex lg:justify-center mt-2 lg:mt-0 relative  ">

                      {timeLeft >= 1 ? (
                        <Button
                        sx={{
                          textTransform: "none",
                          bgcolor: "#605BFF",
                          color: "white",
                          py: "1px",
                          px: "10px",
                          borderRadius: "7px",
                          fontSize: { lg: "14px", xs: "12px" },
                        }}
                      >
                        Expires {timeLeft}
                      </Button>
                      ): (
                    <Button
                      sx={{
                        textTransform: "none",
                        bgcolor: "#605BFF",
                        color: "white",
                        py: "1px",
                        px: "1px",
                        borderRadius: "7px",
                        fontSize: { lg: "14px", xs: "12px" },
                      }}
                      onClick={sendPhoneVerificationSms}
                    >
                      Verify
                    </Button>

                      )}
                    </div>
              </div>

              {code_sent && (

              <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                  Verification Code
                  <img
                    src="/icons/tooltip.png"
                    className="w-[15px] lg:ml-3 ml-1"
                  />
                </div>

                <div className="lg:w-[200px]">
                <InputBase
                        value={channel.code}
                        onChange={(e) => {
                          setChannel({ ...channel, code: e.target.value });
                        }}
                        placeholder="enter verification code"
                        sx={{
                          bgcolor: "#F7F7F8",
                          width: "100%",
                          px: 2,
                          fontSize: { lg: "14px", xs: "12px" },
                        }}
                      />
                </div>

                
                 
              </div>
            )}
            </>
            )}

            {channel?.type === "forward_number" && (
            <>
              <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                  Phone Number
                  <img
                    src="/icons/tooltip.png"
                    className="w-[15px] lg:ml-3 ml-1"
                  />
                </div>

                <div className="lg:w-[200px]">
                  <InputBase
                    value={channel.value}
                    onChange={(e) => {
                      setChannel({ ...channel, value: e.target.value });
                    }}
                    sx={{
                      bgcolor: "#F7F7F8",
                      width: "100%",
                      px: 2,
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                  />
                </div>

            
                    <div className="flex lg:justify-center mt-2 lg:mt-0 relative  ">
                      {timeLeft >=1 ? (
                       <Button
                       sx={{
                         textTransform: "none",
                         bgcolor: "#605BFF",
                         color: "white",
                         py: "1px",
                         px: "10px",
                         borderRadius: "7px",
                         fontSize: { lg: "14px", xs: "12px" },
                       }}
                     >
                       Expires {timeLeft}
                     </Button>
                      ): (
                    <Button
                      sx={{
                        textTransform: "none",
                        bgcolor: "#605BFF",
                        color: "white",
                        py: "1px",
                        px: "1px",
                        borderRadius: "7px",
                        fontSize: { lg: "14px", xs: "12px" },
                      }}
                      onClick={sendPhoneVerificationText}
                    >
                      Verify
                    </Button>

                      )}
                    </div>
              </div>
              
              {code_sent && (

                <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                  <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                    Verification Code
                    <img
                      src="/icons/tooltip.png"
                      className="w-[15px] lg:ml-3 ml-1"
                    />
                  </div>
  
                  <div className="lg:w-[200px]">
                  <InputBase
                          value={channel.code}
                          onChange={(e) => {
                            setChannel({ ...channel, code: e.target.value });
                          }}
                          placeholder="enter verification code"
                          sx={{
                            bgcolor: "#F7F7F8",
                            width: "100%",
                            px: 2,
                            fontSize: { lg: "14px", xs: "12px" },
                          }}
                        />
                  </div>
  
                  
                   
                </div>
              )}
              </>
            )}
{channel?.type === "front" && (
  <>
   { planDetails?.planName !== 'Basic' ? (
              <div>
                <div className="lg:text-[14px] text-[13px] text-center px-8 py-2">
                  {" "}
                  Install our app to your Front workspace. When it asks for an
                  API Key, provide the code below:{" "}
                </div>

                <div className="grid lg:grid-cols-3 items-center lg:space-x-10 space-x-0">
                  <div className="lg:text-[14px] text-[13px] font-semibold flex items-center">
                    Front API key
                    <img
                      src="/icons/tooltip.png"
                      className="w-[15px] lg:ml-3 ml-1"
                    />
                  </div>

                  <div className="lg:w-[200px]">
                    <InputBase
                      readOnly
                      value={channel.value}
                      sx={{
                        bgcolor: "#F7F7F8",
                        width: "100%",
                        px: 2,
                        fontSize: { lg: "14px", xs: "12px" },
                      }}
                    />
                  </div>

                  <div className="flex lg:justify-center mt-2 lg:mt-2 relative  ">
                    <Button
                      sx={{
                        textTransform: "none",
                        bgcolor: "#605BFF",
                        color: "white",
                        py: "1px",
                        px: "1px",
                        borderRadius: "7px",
                        fontSize: { lg: "14px", xs: "12px" },
                      }}
                      onClick={()=> {
                        copyToClipboard(channel.value)
                      }}
                    >
                      {copied ? 'Copied' : 'Copy'}
                    </Button>
                  </div>
                </div>
              </div>
            ):(
              <Alert color='warning' >
                <div className="text-[14px] hover:underline hover:text-blue-600 cursor-pointer " onClick={()=> navigate('/dashboard/settings/billing')}> Upgrade to the Standard Plan to Connect Front </div>
              </Alert>
            )}</>
)}


{channel?.type === "slack" && (
  <>
   { planDetails?.planName !== 'Basic' ? (
              <div>
               
              </div>
            ):(
              <Alert color='warning' >
                <div className="text-[14px] hover:underline hover:text-blue-600 cursor-pointer " onClick={()=> navigate('/dashboard/settings/billing')}> Upgrade to the Standard Plan to Connect Slack </div>
              </Alert>
            )}</>
)}

           

            <div className="flex justify-center pt-6 pb-4 space-x-2">
              <Button
                sx={{
                  textTransform: "none",
                  color: "#605BFF",
                  bgcolor: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={() => {
                  setOpen(false);
                  setChannel({
                    type: "email",
                  });
        
                  setCodeSent(false)
                  setErrormsg(null)
                }}
              >
                Close
              </Button>

              {channel?.type === 'front'  && (
                <>
                { planDetails?.planName !== 'Basic' ? (
               <Button
               sx={{
                 textTransform: "none",
                 bgcolor: "#605BFF",
                 color: "white",
                 py: "4px",
                 px: "40px",
                 borderRadius: "7px",
                 fontSize: { lg: "14px", xs: "12px" },
               }}
               onClick={addChannel}
               disabled={loader}
             >
               {loader ? (
                 <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
               ) : (
                 " Save"
               )}
             </Button>
           ) : (
            <Button
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              py: "4px",
              px: "10px",
              borderRadius: "7px",
              fontSize: { lg: "14px", xs: "12px" },
            }}
            onClick={()=> navigate('/dashboard/settings/billing')}
            disabled={loader}
          >
            {loader ? (
              <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
            ) : (
              " Upgrade Plan"
            )}
          </Button>
           )}
           </>
              )}

{channel?.type === 'slack'  && (
                <>
                { planDetails?.planName !== 'Basic' ? (
               <Button
               sx={{
                 textTransform: "none",
                 bgcolor: "#605BFF",
                 color: "white",
                 py: "4px",
                 px: "40px",
                 borderRadius: "7px",
                 fontSize: { lg: "14px", xs: "12px" },
               }}
               onClick={addChannel}
               disabled={loader}
             >
               {loader ? (
                 <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
               ) : (
                 " Next"
               )}
             </Button>
           ) : (
            <Button
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              py: "4px",
              px: "10px",
              borderRadius: "7px",
              fontSize: { lg: "14px", xs: "12px" },
            }}
            onClick={()=> navigate('/dashboard/settings/billing')}
            disabled={loader}
          >
            {loader ? (
              <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
            ) : (
              " Upgrade Plan"
            )}
          </Button>
           )}
           </>
              )}

           



           {channel?.type === 'forward_number' && (
            <>
              {channels.filter((e)=> e.M.type.S === 'forward_number').length >= planDetails?.forwarding_numbers ? (
  <Button
  sx={{
    textTransform: "none",
    bgcolor: "#605BFF",
    color: "white",
    py: "4px",
    px: "10px",
    borderRadius: "7px",
    fontSize: { lg: "14px", xs: "12px" },
  }}
  disabled={loader}
  onClick={()=> navigate('/dashboard/settings/billing')}
>
  {loader ? (
    <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
  ) : (
    " Upgrade Plan"
  )}
</Button>
              ) : (
                <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "#605BFF",
                  color: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={addChannel}
                disabled={loader}
              >
                {loader ? (
                  <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                ) : (
                  " Save"
                )}
              </Button>
              )}
            </>
           )}



{channel?.type === 'sms' && (
            <>
          
                <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "#605BFF",
                  color: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={addChannel}
                disabled={loader}
              >
                {loader ? (
                  <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                ) : (
                  " Save"
                )}
              </Button>
           
            </>
           )}

{channel?.type === 'email' && (
            <>
          
                <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "#605BFF",
                  color: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={addChannel}
                disabled={loader}
              >
                {loader ? (
                  <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                ) : (
                  " Save"
                )}
              </Button>
           
            </>
           )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default AddChannelModal;
